import { AdmService } from '../../../shared/services/adm.service';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, startWith, switchMap, tap } from 'rxjs';
import { Division } from 'src/app/shared/models/division';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { IdentityRole } from 'src/app/shared/models/identityRole';
import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Pais } from 'src/app/shared/models/pais';
import { Region } from 'src/app/shared/models/region';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Usuario } from 'src/app/shared/models/usuario';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
  selector: 'app-usuarios-dialog',
  templateUrl: './usuarios-dialog.component.html'
})

export class UsuariosDialogComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSelect) multi: MatSelect;
  @ViewChild(MatSelect) single: MatSelect;

  codigoUsuarioEdit: number = -1;
  companias: Compania[] = [];
  dataADevolver: Usuario = null;
  divisiones: Division[] = [];
  hiddenSelectDivisiones: boolean = false;
  idCompaniaEdit: string = "";
  identityRoles: IdentityRole[] = [];
  idPaisEdit: string = "";
  idRegionEdit: string = "";
  idSalesOrgEdit: string = "";
  idTipo: number;
  isLoading = false;
  minLengthTerm = 2;
  multiSelectDivisiones: boolean = false;
  paises: Pais[] = [];
  regiones: Region[] = [];
  rolesConRegion: ItemParametro[] = [];
  rolesMultiDivision: ItemParametro[] = [];
  salesOrgs: SalesOrg[] = [];
  selectRegiones: boolean = false;
  show: boolean = false;
  u: Usuario;
  userNameUsuarioEdit: string = "";
  form: FormGroup;

  formControlMultiDivision: FormControl = new FormControl();
  formControlMultiPais: FormControl = new FormControl();
  formControlSingleDivision: FormControl = new FormControl();
  formControlSinglePais: FormControl = new FormControl();

  public Tooltips: {
    Eliminar: string
  }

  public Etiquetas: {
    Apellido: string
    Pais: string;
    Bloqueado: string
    Buscar: string
    EmailConfirmado: string
    Habilitacion: string
    Nombre: string
    Rol: string
    SinRegistros: string
    UserName: string
    Cuits: string
    CuitsAutocomplete: string
    Email: string
    Compania: string;
    SalesOrg: string;
    Division: string;
    Region: string;
    RecibeMailAutorizacion: string
  }

  public Validaciones: {
    Apellido: string
    UserName: string
    Nombre: string
    Rol: string
    Email: string
    Pais: string;
    Compania: string;
    SalesOrg: string;
    Division: string;
    Region: string;
  }

  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<UsuariosDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private usuarioService: UsuariosService,

    @Inject(MAT_DIALOG_DATA) private data: any) {

    this.form = this.fb.group({

      apellido: ['', [Validators.required, Validators.maxLength(150)]],
      autor: [''],
      bloqueado: [false],
      email: ['', [Validators.required, Validators.maxLength(256), Validators.email]],
      emailConfirmado: [false],
      recibeMailAutorizacion: [false],
      habilitacion: [true],
      nombre: ['', [Validators.required, Validators.maxLength(150)]],
      paises: ['', Validators.required],
      rol: ['', Validators.required],
      region: ['', Validators.required],
      divisiones: ['', Validators.required],
      userName: ['', [Validators.required, Validators.maxLength(256)]],
      codigo: [0]
    })

    //console.log(data);

    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.usuario != null) {
      this.userNameUsuarioEdit = data.usuario.userName;
      this.u = data.usuario;
      this.codigoUsuarioEdit = data.usuario.codigo;
      this.idRegionEdit = data.usuario.idRegion;
      this.idPaisEdit = data.usuario.idPais;

    }
    if (data.rolesConRegion != null) {
      this.rolesConRegion = data.rolesConRegion;
    }

    if (data.rolesMultiDivision != null) {
      this.rolesMultiDivision = data.rolesMultiDivision;
    }

  }

  ngOnInit() {

    this.Etiquetas = {
      Apellido: this.configService.etiquetas.Usuarios.Dialog.Apellido,
      Bloqueado: this.configService.etiquetas.Usuarios.Dialog.Bloqueado,
      Buscar: this.configService.etiquetas.Buscar,
      Cuits: this.configService.etiquetas.Usuarios.Dialog.Cuits,
      CuitsAutocomplete: this.configService.etiquetas.Usuarios.Dialog.CuitsAutocomplete,
      Email: this.configService.etiquetas.Usuarios.Dialog.Email,
      EmailConfirmado: this.configService.etiquetas.Usuarios.Dialog.EmailConfirmado,
      Habilitacion: this.configService.etiquetas.Habilitacion,
      Nombre: this.configService.etiquetas.Usuarios.Dialog.Nombre,
      Rol: this.configService.etiquetas.Usuarios.Dialog.Rol,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      UserName: this.configService.etiquetas.Usuarios.Dialog.UserName,
      Pais: this.configService.etiquetas.Usuarios.Dialog.Pais,
      Compania: this.configService.etiquetas.Usuarios.Dialog.Compania,
      SalesOrg: this.configService.etiquetas.Usuarios.Dialog.SalesOrg,
      Division: this.configService.etiquetas.Usuarios.Dialog.Division,
      Region: this.configService.etiquetas.Usuarios.Dialog.Region,
      RecibeMailAutorizacion: this.configService.etiquetas.Usuarios.Dialog.RecibeMailAutorizacion,
    }

    this.Tooltips = {
      Eliminar: this.configService.tooltips.Eliminar
    }

    this.Validaciones = {
      Apellido: this.configService.validaciones.Usuarios.Dialog.Apellido,
      Nombre: this.configService.validaciones.Usuarios.Dialog.Nombre,
      UserName: this.configService.validaciones.Usuarios.Dialog.UserName,
      Email: this.configService.validaciones.Usuarios.Dialog.Email,
      Pais: this.configService.validaciones.Usuarios.Dialog.Pais,
      Rol: this.configService.validaciones.Usuarios.Dialog.Rol,
      Compania: this.configService.validaciones.Usuarios.Dialog.Compania,
      SalesOrg: this.configService.validaciones.Usuarios.Dialog.SalesOrg,
      Division: this.configService.validaciones.Usuarios.Dialog.Division,
      Region: this.configService.validaciones.Usuarios.Dialog.Region,
    }

    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.dataADevolver));
    this.idPaisEdit = this.loggedService.logged.idPais;
    this.idCompaniaEdit = this.loggedService.logged.idCompania;
    this.idSalesOrgEdit = this.loggedService.logged.idSalesOrg;
    forkJoin([
      this.admService.cPaises(),
      this.usuarioService.cRoles(),
      this.admService.cRegiones(this.idPaisEdit, this.idCompaniaEdit, this.idSalesOrgEdit),
      this.usuarioService.cUsuarioDB(this.codigoUsuarioEdit, this.userNameUsuarioEdit)

    ]).subscribe((data: [Pais[], IdentityRole[], Region[], Usuario]) => {

      if (data[0].length) {

        this.paises = data[0];
      }

      if (data[1].length) {

        this.identityRoles = data[1];
      }

      if (data[2].length) {

        this.regiones = data[2];
      }

      if (this.idTipo == 1) {
        this.regiones = [];
      }

      if (typeof this.u != 'undefined') {
        if (typeof this.u.userName != 'undefined') {

          if (data[3] != null) {

            let idsPaises: string = data[3].paises.map(function (p) {
              return p.id;
            }).join(",");
            if (idsPaises.length) {
              this.usuarioService
                .cDivisionesPaises(idsPaises)
                .subscribe((d: Division[]) => {
                  this.form.controls['divisiones'].reset();
                  this.divisiones = [];
                  this.divisiones = d;
                  this.form.controls['apellido'].setValue(data[3].apellido);
                  this.form.controls['autor'].setValue(data[3].autor);
                  this.form.controls['bloqueado'].setValue(data[3].bloqueado);
                  this.form.controls['email'].setValue(data[3].email);
                  this.form.controls['emailConfirmado'].setValue(data[3].emailConfirmado);
                  this.form.controls['habilitacion'].setValue(data[3].habilitacion);
                  this.form.controls['nombre'].setValue(data[3].nombre);
                  this.form.controls['region'].setValue(data[3].region);
                  this.form.controls['rol'].setValue(data[3].rol);
                  this.form.controls['userName'].setValue(data[3].userName);
                  this.form.controls['recibeMailAutorizacion'].setValue(data[3].recibeMailAutorizacion);
     
                  this.form.markAsPristine();

                  if (this.loggedService.isInRole("CONSULTOR")) {
                    this.form.disable();
                  }

                  this.cRolConRegion(data[3].rol);
                  this.cRolMultiDivision(data[3].rol);
                  this.cDivisionesRolAdm(data[3].rol);
                  this.cPaisesRolAdm(data[3].rol);

                  if (this.multiSelectDivisiones) {
                    this.formControlSingleDivision.reset();
                    this.formControlSinglePais.reset();
                    this.formControlMultiDivision.setValue(data[3].divisiones);
                    this.formControlMultiPais.setValue(data[3].paises);
                    this.form.controls['divisiones'].setValue(this.formControlMultiDivision.value);
                    this.form.controls['paises'].setValue(this.formControlMultiPais.value);

                  }
                  else {
                    this.formControlMultiDivision.reset();
                    this.formControlMultiPais.reset();
                    let d: Division[] = [];
                    let p: Pais[] = [];

                    data[3].divisiones.forEach(e => {
                      d.push(e);
                    });
                    this.formControlSingleDivision.setValue(d[0]);

                    this.form.controls['divisiones'].setValue(d);

                    data[3].paises.forEach(c => {
                      p.push(c);
                    });
                    this.formControlSinglePais.setValue(p[0]);

                    this.form.controls['paises'].setValue(p);
                  }
                });
            }



          }

        }
      }
    });
  }



  guardarUsuario(cerrarDialog: boolean) {


    switch (this.idTipo) {
      case 1:
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        this.usuarioService.aUsuario(this.form.value).subscribe((data: Usuario) => {
          this.dataADevolver = data;
          if (cerrarDialog) {
            this.dialogRef.close(this.dataADevolver);
          }
        })
        break;

      case 2:
        this.form.controls['userName'].setValue(this.userNameUsuarioEdit);
        this.form.controls['codigo'].setValue(this.codigoUsuarioEdit);
        this.usuarioService
          .mUsuario(this.userNameUsuarioEdit, this.form.value)
          .subscribe((data: Usuario) => {
            this.dataADevolver = data;

            if (cerrarDialog) {
              this.dialogRef.close(this.dataADevolver);
            }
            else {
              this.form.markAsPristine();

            }
          });
        break;
    }

  }


  compareIdentityRoles(rolLista: any, rolUsuario: any): boolean {
    return rolLista && rolUsuario ? rolLista.id === rolUsuario.id : rolLista === rolUsuario;
  }

  comparePaises(paisLista: any, paisUsuario: any): boolean {
    return paisLista && paisUsuario ? paisLista.id === paisUsuario.id : paisLista === paisUsuario;
  }

  compareCompanias(compLista: any, compUsuario: any): boolean {
    return compLista && compUsuario ? compLista.id === compUsuario.id : compLista === compUsuario;
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgUsuario: any): boolean {
    return salesOrgLista && salesOrgUsuario ? salesOrgLista.id === salesOrgUsuario.id : salesOrgLista === salesOrgUsuario;
  }
  compareDivisiones(divisionLista: any, divisionUsuario: any): boolean {
    return divisionLista.idPais == divisionUsuario.idPais && divisionLista.id == divisionUsuario.id;
  }

  compareRegiones(regionLista: any, regionUsuario: any): boolean {
    return regionLista && regionUsuario ? regionLista.id === regionUsuario.id : regionLista === regionUsuario;
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  cDivisionesRolAdm(rol: any) {
    if (rol.name == 'ADM') {
      let divisionPlaceHolder: Division = new Division();
      let d: Division[] = [];
      d.push(divisionPlaceHolder);
      this.form.controls['divisiones'].setValue(d);
      this.hiddenSelectDivisiones = true;
    }
    else {
      this.hiddenSelectDivisiones = false;
    }
  }

  cPaisesRolAdm(rol: any) {
    if (rol.name == 'ADM') {
      let paisPlaceHolder: Pais = new Pais();
      let p: Pais[] = [];
      p.push(paisPlaceHolder);
      this.form.controls['paises'].setValue(p);
      this.hiddenSelectDivisiones = true;
    }
    else {
      this.hiddenSelectDivisiones = false;
    }
  }

  selectRol(rol: any) {
    if (typeof rol != 'undefined') {
      if (rol != "-1") {
        this.formControlSingleDivision.reset();
        this.formControlMultiDivision.reset();
        this.formControlSinglePais.reset();
        this.formControlMultiPais.reset();
        this.form.controls['divisiones'].reset();
        this.form.controls['paises'].reset();
        this.regiones = [];
        this.divisiones = [];
        this.cRolConRegion(rol);
        this.cRolMultiDivision(rol);
        this.cDivisionesRolAdm(rol);
        this.cPaisesRolAdm(rol);

      }
      else {
        this.form.controls['region'].reset();
        this.form.controls['rol'].reset();
      }

    }

  }

  cRolConRegion(rol: any) {
    if (this.rolesConRegion.length) {
      let rolObtenido: string = "";
      if (rol.name != null) {
        rolObtenido = rol.name;

        if (this.rolesConRegion.find(e => e.idItem == rolObtenido)) {
          if (this.form.controls['region'].disabled) {
            this.form.controls['region'].enable();
            this.form.controls['region'].reset();
          }
          this.selectRegiones = true;
        }
        else {
          this.form.controls['region'].disable();
          this.selectRegiones = false;
        }

      }
    }

  }

  cRolMultiDivision(rol: any) {
    if (this.rolesMultiDivision.length) {
      let rolObtenido: string = "";
      if (rol.name != null) {
        rolObtenido = rol.name;

        if (this.rolesMultiDivision.find(e => e.idItem == rolObtenido)) {
          this.multiSelectDivisiones = true;
        }
        else {

          this.multiSelectDivisiones = false;
        }


      }
    }

  }

  // selectPais(pais: any) {
  //   if (typeof pais != 'undefined') {
  //     this.salesOrgs = [];
  //     this.form.controls['salesOrg'].reset();
  //     this.companias = [];
  //     this.form.controls['compania'].reset();
  //     this.divisiones = [];
  //     this.formControlSingleDivision.reset();
  //     this.formControlMultiDivision.reset();
  //     this.form.controls['divisiones'].reset();
  //     this.regiones = [];
  //     this.form.controls['region'].reset();
  //     if (pais != "-1") {

  //       this.admService.cCompanias(pais.id).subscribe((data: Compania[]) => {
  //         this.companias = [];
  //         this.companias = data;

  //       });
  //     }
  //     else {
  //       this.form.controls['pais'].reset();
  //     }
  //   }


  // }

  // selectCompania(compania: any) {
  //   if (typeof compania != 'undefined') {
  //     this.salesOrgs = [];
  //     this.form.controls['salesOrg'].reset();
  //     this.divisiones = [];
  //     this.formControlSingleDivision.reset();
  //     this.formControlMultiDivision.reset();
  //     this.form.controls['divisiones'].reset();
  //     this.regiones = [];
  //     this.form.controls['region'].reset();
  //     if (compania != "-1") {

  //       this.admService.cSalesOrgs(compania.idPais, compania.id).subscribe((data: SalesOrg[]) => {
  //         this.salesOrgs = [];
  //         this.salesOrgs = data;

  //       });
  //     }
  //     else {
  //       this.form.controls['compania'].reset();
  //     }
  //   }


  // }

  // selectSalesOrg(salesOrg: any) {
  //   if (typeof salesOrg != 'undefined') {
  //     this.divisiones = [];
  //     this.formControlSingleDivision.reset();
  //     this.formControlMultiDivision.reset();
  //     this.form.controls['divisiones'].reset();
  //     this.regiones = [];
  //     this.form.controls['region'].reset();
  //     if (salesOrg != "-1") {

  //       this.admService.cDivisiones(salesOrg.idPais, salesOrg.idCompania, salesOrg.id, this.loggedService.logged.userName).subscribe((data: Division[]) => {
  //         this.divisiones = [];
  //         this.divisiones = data;

  //       });

  //       this.admService.cRegiones(salesOrg.idPais, salesOrg.idCompania, salesOrg.id).subscribe((data: Region[]) => {
  //         this.regiones = [];
  //         this.regiones = data;

  //       });
  //     }
  //     else {
  //       this.form.controls['salesOrg'].reset();
  //     }
  //   }
  // }

  selectMultiDivision(divisiones: any) {
    if (typeof divisiones != 'undefined') {

      if (divisiones == '-1') {
        this.form.controls['divisiones'].reset();
        this.formControlMultiDivision.reset();
      }
      else {
        this.form.controls['divisiones'].setValue(divisiones);

      }

    }
  }

  selectSingleDivision(division: any) {
    if (typeof division != 'undefined') {
      if (division == '-1') {
        this.form.controls['divisiones'].reset();
        this.formControlSingleDivision.reset();
      }
      else {
        let d: Division[] = [];
        d.push(division)
        this.form.controls['divisiones'].setValue(d);
      }

    }
  }

  selectMultiPais(paises: any) {
    if (typeof paises != 'undefined') {
      this.form.controls['divisiones'].reset();
      this.formControlMultiDivision.reset();
      this.divisiones = [];
      if (paises == '-1') {
        this.form.controls['paises'].reset();
        this.formControlMultiPais.reset();
      }
      else {
        this.form.controls['paises'].setValue(paises);

        let idsPaises: string = paises.map(function (p) {
          return p.id;
        }).join(",");
        if (idsPaises.length) {
          this.usuarioService
            .cDivisionesPaises(idsPaises)
            .subscribe((data: Division[]) => {
              this.form.controls['divisiones'].reset();
              this.divisiones = [];
              this.divisiones = data;
            });
        }
      }

    }
  }

  selectSinglePais(pais: any) {
    if (typeof pais != 'undefined') {

      this.form.controls['divisiones'].reset();
      this.formControlSingleDivision.reset();
      this.form.controls['region'].reset();
      this.regiones = [];
      this.divisiones = [];

      if (pais == '-1') {
        this.formControlSinglePais.reset();
        this.form.controls['paises'].reset();
      }
      else {
        let p: Pais[] = [];
        p.push(pais)
        this.form.controls['paises'].setValue(p);
        this.admService
          .cRegiones(pais.id, null, null)
          .subscribe((data: Region[]) => {

            this.regiones = data;
          });

        this.usuarioService
          .cDivisionesPaises(pais.id)
          .subscribe((data: Division[]) => {

            this.divisiones = data;
          });

      }

    }
  }

  selectRegion(region: any) {
    if (region == '-1') {
      this.form.controls['region'].reset();
    }
  }
}

